import actions from 'actions/formBatches'
import customerActions from 'actions/customers'
import formTemplateActions from 'actions/formTemplates'
import { createFormViewContainer } from 'factories/FormView'
import Component from 'components/FormBatches/FormView'

export default createFormViewContainer({
  actions,
  extraDispatchToProps: (dispatch, props) => ({
    getCustomersList: (params) => dispatch(customerActions.getOptions(params)),
    getCustomersHierarchy: (params) => dispatch(customerActions.getHierarchy(params)),
    getFormTemplates: (params) => dispatch(formTemplateActions.getOptions(params)),
  }),
})(Component)
